// extracted by mini-css-extract-plugin
export default {"timeView":"index_timeView__9q+KQ","colon":"index_colon__S0Xnk"};